import { DefaultState } from 'store/reducers/types';

export const READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_REQUEST = "READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_REQUEST";
export const READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_SUCCESS = "READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_SUCCESS";
export const READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_FAILURE = "READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_FAILURE";

export interface TravelMerchandiserDedicatedReportRow {
  id: number;
  associatesCount: number;
  future: number;
  inThreeWeeks: number;
  inTwoWeeks: number;
  nextWeek: number;
  team: string;
  thisWeek: number;
  workedLastDays: number;
};

export interface TravelMerchandiserDedicatedReportData {
  rows: TravelMerchandiserDedicatedReportRow[] | [];
  totalCount: number;
};

export type TravelMerchandiserDedicatedReportState = DefaultState & {
  contents?: TravelMerchandiserDedicatedReportData;
};

interface ReadTravelMerchandiserDedicatedReportDataRequest {
  type: typeof READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_REQUEST;
};

interface ReadTravelMerchandiserDedicatedReportDataSuccess {
  type: typeof READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_SUCCESS,
  contents: TravelMerchandiserDedicatedReportData;
}

interface ReadTravelMerchandiserDedicatedReportDataFailure {
  type: typeof READ_TRAVEL_MERCHANDISER_DEDICATED_REPORT_DATA_FAILURE;
}

export type TravelMerchandiserDedicatedReportActionTypes = ReadTravelMerchandiserDedicatedReportDataRequest | ReadTravelMerchandiserDedicatedReportDataSuccess | ReadTravelMerchandiserDedicatedReportDataFailure;
  